export default "__VITE_ASSET__5QYQZB2z__"